
















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import api from '@/services/api'
import { take } from 'rxjs/operators'

@Component
export default class extends Vue {
    @Prop()
    message: any
    @Prop()
    prevMessage: any
    @Prop()
    nextMessage: any
    getTimeFromTimestamp(timeStamp: number) {
        const date = new Date(timeStamp)
        return date.getHours() + ':' + date.getMinutes()
    }
    async getCardText(id: string) {
        const card = await api.service('idea-cards').get(id)
        const user = await api.user.pipe(take(1)).toPromise()
        const genderId = user.gender === 'f' ? 'her' : 'him'
        setTimeout(() => {
            // this.calculateHeight()
            this.emitLoad()
        }, 0)
        return card[genderId]
    }
    emitLoad() {
        
        this.$emit('load');
    }
    getImgUrl(name: string) {
        const images = require.context('@/assets/aemoji/', false, /\.gif$/)
        console.log(images('./' + name + '.gif'))
        return images('./' + name + '.gif')
    }
    async getVideo(id: string) {
        const gif = await api.service('gifs').get(id)
        setTimeout(() => {
            // this.calculateHeight()
            this.emitLoad()
        }, 0)
        console.log(gif);
        return {
            ...gif,
            src: 'data:video/' + gif.type +';base64,'+gif.data
        }
    }
}
